import Alert from '@storeblocks/alert';
import styled from 'styled-components';

export const EnterSomeSearchCriteriaAlert = styled(Alert)`
  margin-top: 16px;
`;
